var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaterial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1883_62834)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 12.2727V3.00195L8.25 7.63734V10.7276L2.75 7.63734V13.8179L0 12.2727Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7.63734L16.5 3.00195V12.2727L11 15.363L8.25 13.8179L13.75 10.7276V7.63734L8.25 10.7276V7.63734Z",
    fill: "#0081CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25 13.8184V16.9086L13.75 19.9989V16.9086L8.25 13.8184Z",
    fill: "#00B0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.75 19.9984L22 15.363V9.18247L19.25 10.7276V13.8179L13.75 16.9081V19.9984ZM19.25 7.63734V4.54708L22 3.00195V6.09221L19.25 7.63734Z",
    fill: "#0081CB"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1883_62834"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 17,
    fill: "white",
    transform: "translate(0 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaterial);
export default __webpack_public_path__ + "static/media/material.0e024ec070c69ad9a1627ee5485cb066.svg";
export { ForwardRef as ReactComponent };